export default "__VITE_ASSET__C2kQNIev__"